import { Overlay, OverlayRef } from '@angular/cdk/overlay';

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loading: boolean = false;

  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  // constructor() {}

  // getLoading(): boolean {
  //   return this.loading;
  // }

  private readonly overlayRef: OverlayRef | null = null;

  constructor(private readonly overlay: Overlay) {}

  show() {
    this.loadingSubject.next(true);
  }

  hide() {
    this.loadingSubject.next(false);
  }

  setLoading(loading: boolean) {
    this.loading = loading;
    this.loadingSubject.next(loading); // update observable
  }

  getLoading(): boolean {
    return this.loadingSubject.getValue();
  }
}
